module.exports = __webpack_public_path__ + "static/media/hero_patient_fr_text@2x.f5784b49.png";